import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { _setAxios } from '../../lib/Helper';

async function fetchList(modul, tingkatanKelas) {

  if (!modul) {
    return []
  }

  return await _setAxios("ubudiyah/aspek/kategori/dropdown", "POST", {
    modul: modul,
    tingkatan_kelas: tingkatanKelas
  })
    .then(body => {
      let results = []
      body.data?.data?.forEach(row => {
        results.push({
          label: row.nama,
          value: row.id,
        })
      });

      return results
    })
}

const SelectAspekKategoriUbudiyah = ({ ...props }) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    fetchList(props.modul, props.tingkatanKelas).then((newOptions) => {
      setOptions(newOptions);
    });
  }, [props.modul, props.tingkatanKelas]);

  return (
    <Select
      {...props}
      fetchOptions={fetchList}
      placeholder="Pilih aspek kategori"
      style={{
        width: '100%',
      }}
      options={options}
    />
  );
};
export default SelectAspekKategoriUbudiyah;
